import { entregarArchivo, puedeDescargar } from "../../../../utils/entregarArchivo";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import HttpManager from "../../../../services/HttpManager";
import { Agrupado, Llamada } from "../../../../services/v2/telefonia.service";
import { Aviso, cuando, DIR_TXT, DISP_CLASE, DISP_TXT, errorTexto, minutos, num, pct, seg, telBonito } from "./comunes";
import { Periodo } from "./tablero";
import { Compartido } from "./telefoniaController";

const iso = (d: Date) => d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
const AGRUPAR: [string, string][] = [["", "Sin agrupar (lista)"], ["asesora", "Asesora"], ["equipo", "Equipo"], ["plantel", "Plantel"], ["departamento", "Departamento"],
	["dia", "Día"], ["semana", "Semana"], ["mes", "Mes"], ["hora", "Hora del día"], ["resultado", "Resultado"], ["direccion", "Dirección"], ["numero", "Número"]];

/** Historial de llamadas con filtros, reproductor de grabación, agrupar por lo que sea y exportar a Excel (CSV). */
const Llamadas: React.FC<{ sh: Compartido }> = ({ sh }) => {
	const http = HttpManager.getInstance();
	const navigate = useNavigate();
	const [f, setF] = useState<any>({ desde: iso(new Date()), hasta: iso(new Date()), campus_id: "", direction: "", extension: "", team: "", queue: "", disposition: "", result: "", min_seg: "", grabadas: false, q: "", internas: false });
	const [por, setPor] = useState<string>("");
	const [page, setPage] = useState<number>(1);
	const [d, setD] = useState<{ llamadas: Llamada[]; total: number; porPagina: number } | null>(null);
	const [g, setG] = useState<Agrupado | null>(null);
	const [audio, setAudio] = useState<{ id: number; url: string } | null>(null);
	const [error, setError] = useState<string | null>(null);
	const [busy, setBusy] = useState<boolean>(false);

	const cargar = () => {
		setBusy(true); setError(null);
		const p = por ? http.telefoniaService.agrupado(sh.campusId, f, por).then((r) => { setG(r.data); setD(null); })
			: http.telefoniaService.llamadas(sh.campusId, f, page).then((r) => { setD(r.data); setG(null); });
		p.catch((e) => setError(errorTexto(e))).finally(() => setBusy(false));
	};
	useEffect(cargar, [sh.campusId, por, page, f.desde, f.hasta, f.campus_id, f.direction, f.extension, f.team, f.queue, f.disposition, f.result, f.min_seg, f.grabadas, f.internas]);
	useEffect(() => { setPage(1); }, [f.desde, f.hasta, f.campus_id, f.direction, f.extension, f.team, f.queue, f.disposition, f.result, f.min_seg, f.grabadas, f.q, por]);

	const oir = async (l: Llamada) => {
		if (audio?.id === l.id) return setAudio(null);
		setError(null);
		try {
			const r = await http.telefoniaService.grabacion(sh.campusId, l.id);
			if (!r.data.url) return setError("La grabación todavía no llega de la central (tarda un par de minutos).");
			setAudio({ id: l.id, url: r.data.url });
		} catch (e) { setError(errorTexto(e)); }
	};
	const [puedeBajar, setPuedeBajar] = useState<boolean>(false);
	useEffect(() => { puedeDescargar().then(setPuedeBajar); }, []);
	// La grabación pasa por la regla de descargas: a la computadora solo quien puede; los demás, a su WappDrive.
	const bajarGrabacion = async (l: Llamada) => {
		if (!audio) return;
		try {
			const b = await (await fetch(audio.url)).blob();
			const ext = (b.type.split("/")[1] || "wav").replace("mpeg", "mp3").replace("x-wav", "wav");
			await entregarArchivo(b, `Grabación de llamada ${l.id}.${ext}`, "Grabaciones de llamadas");
		} catch (e) { setError("No se pudo bajar la grabación. Intenta otra vez."); }
	};
	const exportar = async () => {
		try {
			const r = await http.telefoniaService.exportar(sh.campusId, f);
			await entregarArchivo(r.data, "llamadas_" + f.desde + "_" + f.hasta + ".csv", "Telefonía");
		} catch (e) { setError(errorTexto(e)); }
	};
	const paginas = d ? Math.max(1, Math.ceil(d.total / d.porPagina)) : 1;

	return (
		<>
			<Periodo f={f} setF={setF} planteles={sh.cat.planteles} />
			<div className="tf-filtros">
				<div className="tf-campo"><label>Dirección</label><select value={f.direction} onChange={(e) => setF({ ...f, direction: e.target.value })}><option value="">Entrantes y salientes</option><option value="in">Entrantes</option><option value="out">Salientes</option><option value="interna">Internas</option></select></div>
				<div className="tf-campo"><label>Asesora</label><select value={f.extension} onChange={(e) => setF({ ...f, extension: e.target.value })}><option value="">Todas</option>{sh.extensiones.map((x) => <option key={x.extension} value={x.extension}>{x.name} · {x.extension}</option>)}</select></div>
				<div className="tf-campo"><label>Equipo</label><select value={f.team} onChange={(e) => setF({ ...f, team: e.target.value })}><option value="">Todos</option>{sh.cat.equipos.map((t) => <option key={t} value={t}>{t}</option>)}</select></div>
				<div className="tf-campo"><label>Departamento</label><select value={f.queue} onChange={(e) => setF({ ...f, queue: e.target.value })}><option value="">Todos</option>{sh.colas.map((c) => <option key={c.code} value={c.code}>{c.name}</option>)}</select></div>
				<div className="tf-campo"><label>Cómo terminó</label><select value={f.disposition} onChange={(e) => setF({ ...f, disposition: e.target.value })}><option value="">Todas</option>{Object.entries(DISP_TXT).map(([k, t]) => <option key={k} value={k}>{t}</option>)}<option value="abandonada,vencida">Perdidas en cola</option></select></div>
				<div className="tf-campo"><label>Resultado (asesora)</label><select value={f.result} onChange={(e) => setF({ ...f, result: e.target.value })}><option value="">Todos</option>{Object.entries(sh.cat.resultados).map(([k, t]) => <option key={k} value={k}>{t}</option>)}</select></div>
				<div className="tf-campo"><label>Mínimo (s)</label><input type="number" min={0} style={{ width: 80 }} value={f.min_seg} onChange={(e) => setF({ ...f, min_seg: e.target.value })} /></div>
				<div className="tf-campo"><label>Buscar</label><input type="search" placeholder="Nombre o número" value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} onKeyDown={(e) => { if (e.key === "Enter") cargar(); }} /></div>
				<label className="cp-check"><input type="checkbox" checked={f.grabadas} onChange={(e) => setF({ ...f, grabadas: e.target.checked })} />Solo con grabación</label>
				<div className="tf-campo"><label>Agrupar por</label><select value={por} onChange={(e) => setPor(e.target.value)}>{AGRUPAR.map(([k, t]) => <option key={k} value={k}>{t}</option>)}</select></div>
				<button className="nu-btn" onClick={cargar} disabled={busy}>Buscar</button>
				<button className="nu-btn" onClick={exportar}>Exportar a Excel</button>
			</div>
			<Aviso texto={error} onClose={() => setError(null)} />
			{g ? (
				<div className="nu-bloque">
					<div className="nu-bloque-tit">Por {AGRUPAR.find((a) => a[0] === por)?.[1]?.toLowerCase()}</div>
					<table className="nu-tabla">
						<thead><tr><th>Grupo</th><th>Llamadas</th><th>Entrantes</th><th>Salientes</th><th>Contestadas</th><th>%</th><th>Perdidas en cola</th><th>Hablado</th><th>Promedio</th><th>Espera</th><th>Grabadas</th></tr></thead>
						<tbody>
							{g.filas.map((r) => (
								<tr key={String(r.grupo)}><td>{por === "hora" ? ((Number(r.grupo) % 12) || 12) + (Number(r.grupo) < 12 ? " am" : " pm") : por === "resultado" ? (sh.cat.resultados[r.grupo] || DISP_TXT[r.grupo] || r.grupo) : por === "direccion" ? DIR_TXT[r.grupo] : por === "numero" ? telBonito(r.grupo) : r.grupo}</td>
									<td>{num(r.total)}</td><td>{num(r.entrantes)}</td><td>{num(r.salientes)}</td><td>{num(r.contestadas)}</td><td>{pct(r.contestadas, r.total)}</td><td>{num(r.perdidas_cola)}</td>
									<td>{minutos(r.hablado)}</td><td>{seg(r.promedio)}</td><td>{r.espera !== null ? Math.round(Number(r.espera)) + " s" : "–"}</td><td>{num(r.grabadas)}</td></tr>
							))}
							{!g.filas.length ? <tr><td colSpan={11} className="nu-vacio">Nada con estos filtros.</td></tr> : null}
						</tbody>
					</table>
				</div>
			) : (
				<div className="nu-bloque">
					<table className="nu-tabla">
						<thead><tr><th>Cuándo</th><th className="izq">Dir.</th><th className="izq">Asesora</th><th className="izq">Número</th><th className="izq">Cliente</th><th className="izq">Departamento</th><th className="izq">Cómo terminó</th><th className="izq">Resultado</th><th>Esperó</th><th>Habló</th><th>Grabación</th></tr></thead>
						<tbody>
							{(d?.llamadas || []).map((l) => (
								<React.Fragment key={l.id}>
									<tr>
										<td>{cuando(l.started_at)}</td>
										<td className="izq"><span className={"tf-chip " + (l.direction === "in" ? "in" : "")}>{DIR_TXT[l.direction]}</span></td>
										<td className="izq">{l.asesora || l.extension || "–"}</td>
										<td className="izq">{telBonito(l.remote_number)}</td>
										<td className="izq">{l.prospect_id ? <button className="nu-btn chico" onClick={() => navigate("/prospects?id=" + l.prospect_id)}>{l.cliente || l.wa_nombre || "Ver ficha"}</button> : <span className="nu-tenue">Sin ficha</span>}</td>
										<td className="izq">{l.departamento || (l.queue_code ? l.queue_code : "–")}</td>
										<td className="izq"><span className={"tf-chip " + (DISP_CLASE[l.disposition] || "")}>{DISP_TXT[l.disposition] || l.disposition}</span></td>
										<td className="izq">{l.result ? sh.cat.resultados[l.result] || l.result : <span className="nu-tenue">–</span>}</td>
										<td>{l.wait_seconds !== null ? l.wait_seconds + " s" : l.ring_seconds ? l.ring_seconds + " s" : "–"}</td>
										<td>{l.talk_seconds ? seg(l.talk_seconds) : "–"}</td>
										<td>{l.bool_recorded ? <button className="nu-btn chico" onClick={() => oir(l)}>{audio?.id === l.id ? "Cerrar" : "▶ Oír"}</button> : <span className="nu-tenue">–</span>}</td>
									</tr>
									{audio?.id === l.id ? <tr><td colSpan={11} className="izq"><div className="tf-audio"><audio controlsList="nodownload" controls autoPlay src={audio.url} /><button className="nu-btn chico" onClick={() => bajarGrabacion(l)}>{puedeBajar ? "Descargar" : "Guardar en WappDrive"}</button></div></td></tr> : null}
								</React.Fragment>
							))}
							{d && !d.llamadas.length ? <tr><td colSpan={11} className="nu-vacio">Nada con estos filtros.</td></tr> : null}
						</tbody>
					</table>
					{d ? (
						<div className="tf-pie">
							<span>{num(d.total)} llamadas</span>
							<span>
								<button className="nu-btn chico" disabled={page <= 1} onClick={() => setPage(page - 1)}>← Anterior</button>
								<span style={{ margin: "0 10px" }}>Página {page} de {paginas}</span>
								<button className="nu-btn chico" disabled={page >= paginas} onClick={() => setPage(page + 1)}>Siguiente →</button>
							</span>
						</div>
					) : null}
				</div>
			)}
		</>
	);
};

export default Llamadas;
